import { useRemoveEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import { useDeleteCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useDeleteUserEntry() {
  return useDeleteCollectionItem(
    CollectionKey.UserEntry,
    "entry",
    useRemoveEntry,
    (i) => i,
  )
}
